import React, { createContext, useContext, useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from './firebase';

const defaults = {
  primary:       '#1a2940',
  secondary:     '#2c4a7c',
  banner_color:  '#ffffff',
  button_bg:     '#1a3a5c',
  button_text:   '#ffffff',
  title:         'Torch Volleyball',
  footer:        'Tournament registration powered by Torch Volleyball.',
  director_email: 'admin@torchvolleyball.com',
  logo_data:     '',
  logo_mime:     'image/png',
};

const TournamentBrandingContext = createContext(defaults);

export function TournamentBrandingProvider({ children }) {
  const [branding, setBranding] = useState(defaults);

  useEffect(() => {
    async function load() {
      try {
        const snap = await getDoc(doc(db, 'settings', 'branding'));
        if (snap.exists()) {
          setBranding({ ...defaults, ...snap.data() });
        }
      } catch (e) {
        console.error('Failed to load branding:', e);
      }
    }
    load();
  }, []);

  return (
    <TournamentBrandingContext.Provider value={branding}>
      {children}
    </TournamentBrandingContext.Provider>
  );
}

export function useBranding() {
  return useContext(TournamentBrandingContext);
}

export default TournamentBrandingContext;
